// extracted by mini-css-extract-plugin
export default {"container":"course-by-student_container__FrWIb","selects":"course-by-student_selects__dgirV"};